export const restorePointsTranslations = {
  ar: {
    title: 'نقاط الاستعادة',
    addNew: 'إضافة نقطة استعادة جديدة',
    name: 'اسم نقطة الاستعادة',
    description: 'الوصف',
    backupType: 'نوع النسخة الاحتياطية',
    backupPath: 'مسار النسخة الاحتياطية',
    createdDate: 'تاريخ الإنشاء',
    fileSize: 'حجم الملف',
    isSystemPoint: 'نقطة نظام',
    actions: 'الإجراءات',
    restore: 'استعادة',
    delete: 'حذف',
    noRestorePoints: 'لا توجد نقاط استعادة',
    restoreSuccess: 'تم الاستعادة بنجاح',
    restoreError: 'فشل الاستعادة',
    deleteSuccess: 'تم الحذف بنجاح',
    deleteError: 'فشل الحذف',
    confirmRestore: 'هل أنت متأكد من استعادة هذه النسخة الاحتياطية؟',
    confirmDelete: 'هل أنت متأكد من حذف هذه النسخة الاحتياطية؟',
  },
  en: {
    title: 'Restore Points',
    addNew: 'Add New Restore Point',
    name: 'Restore Point Name',
    description: 'Description',
    backupType: 'Backup Type',
    backupPath: 'Backup Path',
    createdDate: 'Created Date',
    fileSize: 'File Size',
    isSystemPoint: 'System Point',
    actions: 'Actions',
    restore: 'Restore',
    delete: 'Delete',
    noRestorePoints: 'No restore points',
    restoreSuccess: 'Restored successfully',
    restoreError: 'Restore failed',
    deleteSuccess: 'Deleted successfully',
    deleteError: 'Delete failed',
    confirmRestore: 'Are you sure you want to restore this backup?',
    confirmDelete: 'Are you sure you want to delete this backup?',
  },
  fr: {
    title: 'Points de restauration',
    addNew: 'Ajouter un point de restauration',
    name: 'Nom du point de restauration',
    description: 'Description',
    backupType: 'Type de sauvegarde',
    backupPath: 'Chemin de sauvegarde',
    createdDate: 'Date de création',
    fileSize: 'Taille du fichier',
    isSystemPoint: 'Point système',
    actions: 'Actions',
    restore: 'Restaurer',
    delete: 'Supprimer',
    noRestorePoints: 'Aucun point de restauration',
    restoreSuccess: 'Restauration réussie',
    restoreError: 'Échec de la restauration',
    deleteSuccess: 'Suppression réussie',
    deleteError: 'Échec de la suppression',
    confirmRestore: 'Êtes-vous sûr de vouloir restaurer cette sauvegarde?',
    confirmDelete: 'Êtes-vous sûr de vouloir supprimer cette sauvegarde?',
  },
}

